import { AxiosResponse } from 'axios'
import axios from '@/services/axios'
import type {
  InvoiceInterface,
  InvoiceListParams,
  InvoiceRestorePayload,
} from '@/models/shop/InvoiceV2.types'
import type {
  InvoiceSettingsInterface,
  UpdateInvoiceSettingsPayload,
} from '@/models/shop/InvoiceSettings.types'

export default abstract class InvoicesApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI
  public static entity = 'invoices'

  public static async getArenaInvoices(
    arenaId: string,
    params?: InvoiceListParams,
  ): Promise<
    AxiosResponse<{
      data: InvoiceInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}`
    return await axios.get(url, { params })
  }

  public static async getInvoice(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<InvoiceInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}`
    return await axios.get(url)
  }

  public static async restoreInvoice(
    arenaId: string,
    id: string,
    data: InvoiceRestorePayload,
  ): Promise<AxiosResponse<InvoiceInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/restore`
    return await axios.post(url, data)
  }

  public static async fisclize(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<InvoiceInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/fiscalize`
    return await axios.post(url)
  }

  public static async finishBaFiscalization(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/finish-ba-fiscalization`
    return await axios.post(url)
  }

  public static async generateInvoiceFile(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<InvoiceInterface>> {
    const url = `${this.route}/arenas/${arenaId}/${this.entity}/${id}/generate-file`
    return await axios.post(url)
  }

  public static async getArenaInvoiceSettings(
    arenaId: string,
  ): Promise<AxiosResponse<InvoiceSettingsInterface>> {
    const url = `${this.route}/arenas/${arenaId}/invoice-settings`
    return await axios.get(url)
  }

  public static async updateArenaInvoiceSettings(
    arenaId: string,
    data: UpdateInvoiceSettingsPayload,
  ): Promise<AxiosResponse<InvoiceSettingsInterface>> {
    const url = `${this.route}/arenas/${arenaId}/invoice-settings`
    return await axios.patch(url, data)
  }

  public static async createNullInvoices(): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/jobs/generate-at-null-invoices`)
  }
}
